import React from 'react';
import { Card, CardContent, CardDescription } from "../ui/card";
import { LucideIcon } from 'lucide-react'; // For dynamic icons
import { cn } from '../../lib/utils';

interface StreakCardProps {
  title: string;
  streak: number | undefined | null;
  description: string;
  icon: LucideIcon;
  iconColor?: string; // Optional: e.g., text-orange-500
  isLoading?: boolean;
}

const StreakCard: React.FC<StreakCardProps> = ({ 
  title,
  streak,
  description,
  icon: Icon, // Rename prop for use as component
  iconColor = 'text-primary', // Default color
  isLoading = false,
}) => {
  const displayStreak = streak ?? 0;

  return (
    <Card>
      <CardContent className="pt-6 flex flex-col items-center justify-center text-center h-40">
        {isLoading ? (
          <div className="h-8 w-8 mb-2 rounded-full bg-muted animate-pulse"></div>
        ) : (
          <Icon className={cn("h-8 w-8 mb-2", iconColor)} />
        )}
        {isLoading ? (
          <div className="h-10 w-16 mb-1 rounded bg-muted animate-pulse"></div>
        ) : (
          <div className="text-4xl font-bold">{displayStreak}</div>
        )}
        <CardDescription className="mt-1">
          {isLoading ? <div className="h-4 w-48 rounded bg-muted animate-pulse"></div> : description}
        </CardDescription>
      </CardContent>
    </Card>
  );
};

export default StreakCard; 